import type {
  StepIconProps,
  StepperProps as MuiStepperProps,
  StepProps,
} from '@mui/material';
import Step from '@mui/material/Step';
import StepIcon from '@mui/material/StepIcon';
import StepLabel from '@mui/material/StepLabel';
import { Icon } from 'assets/Icon.js';

import {
  StyledSecondaryStepper,
  StyledStepper,
  StyledSubLabel,
} from './Stepper.styled.js';

export const Stepper = ({
  steps,
  ...props
}: MuiStepperProps & { steps: string[] }) => {
  return (
    <StyledStepper {...props}>
      {steps.map(label => (
        <Step key={label}>
          <StepLabel>{label}</StepLabel>
        </Step>
      ))}
    </StyledStepper>
  );
};

export interface StepperProps extends StepProps {
  steps: { label: string; subLabel?: string }[];
  activeStep: number;
}

export const StepperSecondary = ({
  activeStep,
  steps,
  ...props
}: StepperProps) => {
  return (
    <StyledSecondaryStepper
      activeStep={activeStep}
      style={{ margin: '0 auto' }}
      {...props}
    >
      {steps.map((step, index) => {
        return (
          <Step
            key={`step-${step.label}-${index}`}
            active={activeStep === index}
          >
            <StepLabel
              optional={<StyledSubLabel>{step?.subLabel ?? ''}</StyledSubLabel>}
              slots={{
                stepIcon: ({ completed }: StepIconProps) => {
                  return completed
                    ? (
                        <Icon icon="stepActiveSvg" />
                      )
                    : (
                        <StepIcon icon={index + 1} />
                      );
                },
              }}
            >
              {step.label}
            </StepLabel>
          </Step>
        );
      })}
    </StyledSecondaryStepper>
  );
};
